import React from 'react';
import CalendarView from '../components/Calendar/CalendarView';
import PublicFooter from '../components/Layout/PublicFooter';

const Calendar = () => {
  return (
    <>
      <CalendarView />
      <PublicFooter />
    </>
  );
};

export default Calendar;